import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';

// Layouts
import { PublicLayout } from './layouts/PublicLayout';
import { ProtectedLayout } from './layouts/ProtectedLayout';

// Public Pages
import { Landing } from './pages/public/Landing';
import { Login } from './pages/auth/Login';
import { Register } from './pages/auth/Register';
import { ForgotPassword } from './pages/auth/ForgotPassword';
import { ResetPassword } from './pages/auth/ResetPassword';
import { PublicCard } from './pages/public/PublicCard';
import { QrRedirect } from './pages/public/QrRedirect';
import { NfcRedirect } from './pages/public/NfcRedirect';
import { VCardRoute } from './pages/public/VCardRoute';

// Protected Pages
import { Dashboard } from './pages/app/Dashboard';
import { Onboarding } from './pages/app/Onboarding';
import { Profile } from './pages/app/Profile';
import { Settings } from './pages/app/Settings';

// Analytics & Reviews
import { Analytics } from './pages/app/analytics/Analytics';
import { CardAnalytics } from './pages/app/analytics/CardAnalytics';
import { ReviewNetworking } from './pages/app/review/ReviewNetworking';

// Card Pages
import { CardsList } from './pages/app/cards/CardsList';
import { CreateCard } from './pages/app/cards/CreateCard';
import { CardDetail } from './pages/app/cards/CardDetail';
import { CardEditor } from './pages/app/cards/CardEditor';

// Connections Pages
import { ConnectionsList } from './pages/app/connections/ConnectionsList';
import { RemindersList } from './pages/app/connections/RemindersList';

// Contacts Pages
import { ContactsList } from './pages/app/contacts/ContactsList';

// Moments Pages
import { MomentsList } from './pages/app/moments/MomentsList';

// Events Pages
import { EventsList } from './pages/app/events/EventsList';
import { EventEditor } from './pages/app/events/EventEditor';
import { EventDetail } from './pages/app/events/EventDetail';
import { EventAnalytics } from './pages/app/events/EventAnalytics';
import { EventConnections } from './pages/app/events/EventConnections';

function App() {
  return (
    <AuthProvider>
      <HashRouter>
        <Routes>
          {/* Public Routes */}
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/auth/reset-password" element={<ResetPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/auth/callback" element={<Navigate to="/app/dashboard" />} />
          </Route>

          {/* Standalone Public Routes */}
          <Route path="/c/:slug" element={<PublicCard />} />
          <Route path="/q/:token" element={<QrRedirect />} />
          <Route path="/n/:token" element={<NfcRedirect />} />
          <Route path="/vcard/:slug" element={<VCardRoute />} />

          {/* Protected App Routes */}
          <Route path="/app" element={<ProtectedLayout />}>
            <Route index element={<Navigate to="/app/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="onboarding" element={<Onboarding />} />
            <Route path="profile" element={<Profile />} />
            <Route path="settings" element={<Settings />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="review" element={<ReviewNetworking />} />

            {/* Cards Routing */}
            <Route path="cards" element={<CardsList />} />
            <Route path="cards/new" element={<CreateCard />} />
            <Route path="cards/:id" element={<CardDetail />} />
            <Route path="cards/:id/edit" element={<CardEditor />} />
            <Route path="cards/:id/analytics" element={<CardAnalytics />} />

            {/* Connections & Reminders Routing */}
            <Route path="connections" element={<ConnectionsList />} />
            <Route path="reminders" element={<RemindersList />} />

            {/* Contacts Routing */}
            <Route path="contacts" element={<ContactsList />} />

            {/* Moments Routing */}
            <Route path="moments" element={<MomentsList />} />

            {/* Events Routing */}
            <Route path="events" element={<EventsList />} />
            <Route path="events/new" element={<EventEditor />} />
            <Route path="events/:id" element={<EventDetail />} />
            <Route path="events/:id/edit" element={<EventEditor />} />
            <Route path="events/:id/analytics" element={<EventAnalytics />} />
            <Route path="events/:id/connections" element={<EventConnections />} />
          </Route>

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </HashRouter>
    </AuthProvider>
  );
}

export default App;